import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';

import './CSS/Login.css'; // Import the CSS file

class Login4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      errorMessage: '',
      successMessage: ''
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = this.state;

    if (!(email && password)) {
      this.setState({ errorMessage: 'All inputs are required!' });
      return;
    }

    try {
      const response = await fetch('/send-otp-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email.toLowerCase(),
          password: password,
        }),
      });

      const data = await response.json();

      if (response.status === 200) {
        this.setState({ successMessage: 'Login successful!', errorMessage: '' });

        // Store token in localStorage or sessionStorage
        localStorage.setItem('token', data.token);

        // Show success message for 3 seconds before sending OTP email and redirecting
        setTimeout(async () => {
          // Redirect to the OTP authentication page
          this.props.history.push('/otpauthentication2');
        }, 3000);
      } else {
        this.setState({ errorMessage: 'Invalid Credentials!', successMessage: '' });
      }
    } catch (error) {
      console.log(error);
      this.setState({ errorMessage: 'An error occurred!', successMessage: '' });
    }
  }

  render() {
    return (
      <div className="login-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className='logo' src={logo} alt="Logo" />
          <br />
          <div><Link to='/'>Home</Link></div>
          <br />
          <div>
            Please proceed to login...
          </div>
          <br />
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="email">Email</label>
                      <input type="email" className="form-control" name="email" id="email" value={this.state.email} onChange={this.handleInputChange} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="password">Password</label>
                      <input type="password" className="form-control" name="password" id="password" value={this.state.password} onChange={this.handleInputChange} />
                    </div>
                    {this.state.errorMessage && <div className="alert alert-danger">{this.state.errorMessage}</div>}
                    {this.state.successMessage && <div className="alert alert-success">{this.state.successMessage}</div>}
                    <button type="submit" className="btn btn-dark">Login</button>
                  </form>
                  <div>Powered by</div>
          
                  <img className='logo2' src={logo2} alt="Logo 2" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Login4);
